import React from 'react';
import { teamsData } from '../data/teamsData';
import '../App.css';

const Teams = ({ t }) => {
    return (
        <section className="teams-section">
            <h3>{t.teamsDrivers}</h3>
            <div className="teams-grid">
                {teamsData.map((teamData, index) => (
                    <div
                        key={index}
                        className="team-card"
                        style={{
                            borderTop: `4px solid ${teamData.color}`
                        }}
                    >
                        <div className="team-header">
                            <h4 className="team-name" style={{ color: teamData.color }}>
                                {teamData.team}
                            </h4>
                            <div className="team-principal-section">
                                <span className="team-principal-label">{t.teamPrincipal}:</span>
                                <span className="team-principal-value">{teamData.teamPrincipal}</span>
                            </div>
                        </div>

                        {teamData.image && (
                            <div className="team-car-container">
                                <img
                                    src={teamData.image}
                                    alt={`${teamData.team} Car`}
                                    className="team-car-image"
                                    loading="lazy"
                                />
                            </div>
                        )}

                        <div className="team-details">
                            <div className="drivers-list">
                                <div className="driver-pill">
                                    <span className="driver-flag">{teamData.driver1.flag}</span>
                                    <span className="driver-name">{teamData.driver1.name}</span>
                                </div>
                                <div className="driver-pill">
                                    <span className="driver-flag">{teamData.driver2.flag}</span>
                                    <span className="driver-name">{teamData.driver2.name}</span>
                                </div>
                            </div>

                            {teamData.launchDate && (
                                <div className="car-launch-info">
                                    <span className="car-launch-label">{t.launchDate}:</span>
                                    <span className="car-launch-val">{teamData.launchDate}</span>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Teams;
